module.exports = __webpack_public_path__ + "media/images/flags/ie-33a70f15c7966770192ec58f53493d2a.svg";